import {
  Box,
  IconButton,
  Typography,
  Divider,

  // useMediaQuery,
  FormControlLabel,
  Switch,
  styled,
} from '@mui/material';
import { Close } from '@mui/icons-material';
import {
  AutoCompleteController,
  InputController,
  Button,
} from '../../../components';
import React from 'react';
import { DropDownType, MVPFormData } from '../constants';
import {
  Control,
  FieldErrors,
  UseFormHandleSubmit,
  UseFormRegister,
} from 'react-hook-form';
import { TAutoCompleteOptions } from '../../../utils/types';
import { Controller } from 'react-hook-form';
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store';
type MVPFiltersProps = {
  control: Control<MVPFormData>;
  errors: FieldErrors<MVPFormData>;
  register: UseFormRegister<MVPFormData>;
  handleSubmit: UseFormHandleSubmit<MVPFormData>;
  handleSubmitData: (values: MVPFormData) => void;
  handleErrorOnSubmit: (error: unknown) => void;
  handleBottomSheetOpen: (value: boolean) => void;
  regionManagerList: DropDownType[];
  tpmList: DropDownType[];
  faList: DropDownType[];
  organizerList: DropDownType[];
  indexIdList: DropDownType[];
  regionList: DropDownType[];
  subregionList: DropDownType[];
  clusterList: DropDownType[];
  villageList: DropDownType[];
  cropTypeList: DropDownType[];
  hybridTypeList: DropDownType[];
  seasonTypeList: DropDownType[];
  weeksOfSowing: DropDownType[];
  handleRegionMangerChange: (
    selectedOption: TAutoCompleteOptions | null
  ) => void;
  handleTpmChange: (
    selectedOption: TAutoCompleteOptions | null
  ) => void;
  handleFaChange: (
    selectedOption: TAutoCompleteOptions | null
  ) => void;
  handleOrganizerChange: (
    selectedOption: TAutoCompleteOptions | null
  ) => void;
  handleRegionChange: (
    selectedOption: TAutoCompleteOptions | null
  ) => void;
  handleSubRegionChange: (
    selectedOption: TAutoCompleteOptions | null
  ) => void;
  handleClusterChange: (
    selectedOption: TAutoCompleteOptions | null
  ) => void;
  handleVillageChange: (
    selectedOption: TAutoCompleteOptions | null
  ) => void;
  handelSowingStartDateChange: (
    event: React.ChangeEvent<HTMLInputElement>
  ) => void;
  handleSowingEndDateChange: (
    event: React.ChangeEvent<HTMLInputElement>
  ) => void;
  handleClearAll: () => void;
  setFilterOpen: any;
};

const FiltersView: React.FC<MVPFiltersProps> = ({
  setFilterOpen,
  control,
  errors,
  register,
  handleSubmit,
  handleSubmitData,
  handleErrorOnSubmit,
  // handleBottomSheetOpen,
  regionManagerList,
  tpmList,
  faList,
  organizerList,
  indexIdList,
  regionList,
  subregionList,
  clusterList,
  villageList,
  cropTypeList,
  hybridTypeList,
  seasonTypeList,
  handleRegionMangerChange,
  handleTpmChange,
  handleFaChange,
  handleOrganizerChange,
  handleRegionChange,
  handleSubRegionChange,
  handleClusterChange,
  handleVillageChange,
  handelSowingStartDateChange,
  handleSowingEndDateChange,
  handleClearAll,
}) => {
  // const isMobileView: boolean = useMediaQuery(
  //   '(max-width:1024px)'
  // );
  const isThailand =
    useSelector(
      (state: RootState) => state.country.countryName
    ) === 'Thailand';

  const CustomSwitch = styled(Switch)(() => ({
    '& .MuiSwitch-switchBase.Mui-checked': {
      color: 'rgba(0, 105, 112, 1)',
    },
    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track':
      {
        backgroundColor: 'rgba(0, 105, 112, 1)',
      },
  }));
  return (
    <form
      onSubmit={handleSubmit(
        (data) => handleSubmitData(data),
        (error) => handleErrorOnSubmit(error)
      )}
      style={{
        display: 'flex',
        flexDirection: 'column',
        height: '100vh', // take full viewport height
      }}>
      {/* Header */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          //  p: 2,
          //  borderBottom: '1px solid #eee',
          flexShrink: 0,
          bgcolor: '#fff',
          //  marginTop: 2,
        }}>
        <Box display="flex">
          <FilterAltOutlinedIcon
            sx={{ fontSize: 20, mt: 0.5 }}
          />
          <Typography variant="subtitle1" fontWeight="bold">
            Filter
          </Typography>
        </Box>
        <IconButton onClick={() => setFilterOpen(false)}>
          <Close />
        </IconButton>
      </Box>
      <Divider sx={{ my: 1 }} />
      <Box sx={{ flex: 1 }}>
        <AutoCompleteController
          control={control}
          name="index"
          label="Index"
          placeholder="Select Index"
          options={indexIdList}
          required
          disableClearable
          error={errors?.index?.message}
        />
        <Divider sx={{ my: 1 }} />
        {/* Season */}
        <Typography
          variant="subtitle2"
          fontWeight="bold"
          sx={{ mb: 1 }}>
          Season
        </Typography>

        <AutoCompleteController
          control={control}
          name="season"
          label="Season"
          placeholder="Select Season"
          options={seasonTypeList}
          required
          disableClearable
          error={errors?.season?.message}
        />
        <Divider sx={{ my: 1 }} />
        <Typography
          variant="subtitle2"
          fontWeight="bold"
          sx={{ mb: 1 }}>
          Crop
        </Typography>
        <div>
          <AutoCompleteController
            control={control}
            name="cropType"
            label="Crop"
            placeholder="Select Crop"
            options={cropTypeList}
          />
        </div>
        <div style={{ marginTop: -10 }}>
          <AutoCompleteController
            control={control}
            name="hybridType"
            label="Variety"
            placeholder="Select variety"
            options={hybridTypeList}
          />
        </div>
        <Divider sx={{ my: 1 }} />
        <Typography
          variant="subtitle2"
          fontWeight="bold"
          sx={{ mb: 1 }}>
          Geography
        </Typography>
        <div style={{ marginTop: -10 }}>
          <AutoCompleteController
            control={control}
            name="region"
            label="Region"
            placeholder="Select Region"
            options={regionList}
            onChange={handleRegionChange}
          />
        </div>
        <div style={{ marginTop: -10 }}>
          <AutoCompleteController
            control={control}
            name="subRegion"
            label="Subregion"
            placeholder="Select Subregion"
            options={subregionList}
            onChange={handleSubRegionChange}
          />
        </div>
        {isThailand && (
          <div style={{ marginTop: -10 }}>
            <AutoCompleteController
              control={control}
              name="cluster"
              label="Cluster"
              placeholder="Select Cluster"
              options={clusterList}
              onChange={handleClusterChange}
            />
          </div>
        )}
        <div style={{ marginTop: -10 }}>
          <AutoCompleteController
            control={control}
            name="village"
            label="Village"
            placeholder="Select Village"
            options={villageList}
            onChange={handleVillageChange}
          />
        </div>

        <Divider sx={{ my: 1 }} />

        <Typography variant="subtitle2" fontWeight="bold">
          People
        </Typography>
        <div>
          <AutoCompleteController
            control={control}
            name="regionManager"
            label="Regional Manager"
            placeholder="Select RM"
            options={regionManagerList}
            onChange={handleRegionMangerChange}
          />
        </div>
        <div style={{ marginTop: -10 }}>
          <AutoCompleteController
            control={control}
            name="tpm"
            label="TPM"
            placeholder="Select TPM"
            options={tpmList}
            onChange={handleTpmChange}
          />
        </div>
        <div style={{ marginTop: -10 }}>
          <AutoCompleteController
            control={control}
            name="fa"
            label="Field Agent"
            placeholder="Select FA"
            options={faList}
            onChange={handleFaChange}
          />
        </div>
        <div style={{ marginTop: -10 }}>
          <AutoCompleteController
            control={control}
            name="organizer"
            label="Organizer"
            placeholder="Select organizer"
            options={organizerList}
            onChange={handleOrganizerChange}
          />
        </div>
        <Divider sx={{ my: 1 }} />

        <div style={{ marginRight: 10, marginLeft: -15 }}>
          {/* Season dropdown */}
          {/* Exclude Harvested Fields switch */}
          <Controller
            name="excludeHarvestFlag"
            control={control}
            defaultValue={true}
            render={({ field: { value, onChange } }) => (
              <FormControlLabel
                label="Exclude Harvested Fields"
                labelPlacement="start"
                sx={{
                  justifyContent: 'space-between',
                  // ml: 2,
                  width: '100%',
                }}
                control={
                  <CustomSwitch
                    checked={value}
                    onChange={(event) =>
                      onChange(event.target.checked)
                    }
                    color="primary"
                  />
                }
              />
            )}
          />{' '}
          <Controller
            name="excludePldFlag"
            control={control}
            defaultValue={true}
            render={({ field: { value, onChange } }) => (
              <FormControlLabel
                label="Exclude PLD Fields"
                labelPlacement="start"
                sx={{
                  justifyContent: 'space-between',
                  mr: 10,
                  width: '100%',
                }}
                control={
                  <CustomSwitch
                    checked={value}
                    onChange={(event) =>
                      onChange(event.target.checked)
                    }
                    color="primary"
                  />
                }
              />
            )}
          />
        </div>
        {/* Switches neatly aligned */}

        <Divider sx={{ my: 2 }} />

        {/* Days of Planting */}
        <Typography
          variant="subtitle2"
          fontWeight="bold"
          sx={{ mb: 1 }}>
          Days of Planting
        </Typography>
        <div>
          <InputController
            label="From"
            register={register('sowingStartDate')}
            type="number"
            error={errors?.sowingStartDate?.message}
            onChange={handelSowingStartDateChange}
          />
        </div>
        <div style={{ marginTop: -40, marginBottom: 20 }}>
          <InputController
            label="To"
            register={register('sowingEndDate')}
            type="number"
            error={errors?.sowingEndDate?.message}
            onChange={handleSowingEndDateChange}
          />
        </div>
      </Box>

      {/* Footer Buttons (fixed) */}
      <Box
        sx={{
          // p: 2,
          // borderTop: '1px solid #eee',
          // display: 'flex',
          // justifyContent: 'space-between',
          // bgcolor: '#fff',
          // flexShrink: 0,
          // position: 'sticky',
          // bottom: 40,
          // zIndex: 10,

          p: 2,
          borderTop: '1px solid #eee',
          display: 'flex',
          justifyContent: 'flex-end', // ✅ align both to right
          gap: 2, // ✅ space between buttons
          bgcolor: '#fff',
          flexShrink: 0,
          position: 'sticky',
          bottom: 40,
          zIndex: 10,
        }}>
        <Button
          type="button"
          variant="button--secondary"
          onClick={handleClearAll}>
          Clear All
        </Button>
        <Button type="submit">Apply</Button>
      </Box>
    </form>
  );
};

export default FiltersView;
